import { render, staticRenderFns } from "./vs-form-textarea.vue?vue&type=template&id=ef9b7408&scoped=true"
import script from "./vs-form-textarea.vue?vue&type=script&lang=js"
export * from "./vs-form-textarea.vue?vue&type=script&lang=js"
import style0 from "./vs-form-textarea.vue?vue&type=style&index=0&id=ef9b7408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9b7408",
  null
  
)

export default component.exports